import React, {Fragment} from 'react';
import MetaTags from 'react-meta-tags';

import Loading from '../blocks/loading/Loading';
import Header from '../blocks/header/Header';
import Footer from '../blocks/footer/Footer';

import {useTranslation} from 'react-i18next';
import PageTitleImprint from '../blocks/page-title/PageTitleImprint';

const chamberLinks = [
  {
    href: 'https://www.aerztekammer-hamburg.org/',
    label: 'www.aerztekammer-hamburg.org',
  },
  {
    href: 'https://www.aekn.de/',
    label: 'www.aekn.de',
  },
];

const Impressum = () => {
  document.body.classList.add('page');
  const {t} = useTranslation();

  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8"/>
        <title>{t('meta.title')}</title>
        <meta httpEquiv="x-ua-compatible" content="ie=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta name="description" content={t('meta.description')}/>
        <meta name="keywords" content={t('meta.keywords')}/>
        <meta name="robots" content="index, follow, noodp"/>
        <meta name="googlebot" content="index, follow"/>
        <meta name="format-detection" content="telephone=no"/>
      </MetaTags>

      <Loading/>

      <Header logoColor="dark"/>

      <main id="main" className="site-main">
        <PageTitleImprint/>

        <div id="page-content" className="spacer p-top-xl">
          <div className="wrapper">
            <div className="content">
              <div className="legal-page">
                <section className="legal-page__section">
                  <div className="legal-page__stack">
                    <p>Privatpraxis HanseEuroDerm Partnergesellschaft (PartG)</p>
                    <p>Privatpraxis für Dermatologie und Ästhetische Medizin</p>
                  </div>

                  <div className="legal-page__stack">
                    <p><strong>Sitz der Gesellschaft:</strong></p>
                    <p>Eppendorfer Weg 111</p>
                    <p>20259 Hamburg</p>
                    <p>Deutschland</p>
                  </div>

                  <div className="legal-page__stack">
                    <p><strong>Weiterer Praxisstandort:</strong></p>
                    <p>Fritz-Reuter-Str. 16</p>
                    <p>21629 Neu Wulmstorf</p>
                    <p>Deutschland</p>
                  </div>

                  <p>
                    E-Mail:{' '}
                    <a href="mailto:info@hautarzt-neuwulmstorf.de">
                      info@hautarzt-neuwulmstorf.de
                    </a>
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Partnerschaftsregister</h2>
                  <div className="legal-page__stack">
                    <p>Eingetragen im Partnerschaftsregister</p>
                    <p>Amtsgericht Hamburg</p>
                    <p>PR 1613</p>
                  </div>
                </section>

                <section className="legal-page__section">
                  <h2>Vertretungsberechtigte Partner</h2>
                  <ul className="legal-page__list">
                    <li>Aleksandr Sumenko</li>
                    <li>Dr. Marcel Roswora</li>
                    <li>Dr. Ferhat Yenilmez</li>
                  </ul>
                  <p>Die Partner vertreten gemeinsam.</p>
                </section>

                <section className="legal-page__section">
                  <h2>Berufsbezeichnungen und berufsrechtliche Regelungen</h2>
                  <p>Berufsbezeichnung: Arzt</p>
                  <p>Die Berufsbezeichnungen wurden in der Bundesrepublik Deutschland verliehen.</p>

                  <div className="legal-page__stack legal-page__stack--spaced">
                    <p><strong>Zuständige Ärztekammern</strong></p>
                    <p>Für den Standort Hamburg:</p>
                    <p>Ärztekammer Hamburg</p>
                    <p>Weidestraße 122 b</p>
                    <p>22083 Hamburg</p>
                  </div>

                  <div className="legal-page__stack">
                    <p>Für den Standort Niedersachsen:</p>
                    <p>Ärztekammer Niedersachsen</p>
                    <p>Berliner Allee 20</p>
                    <p>30175 Hannover</p>
                  </div>

                  <p>Es gelten folgende berufsrechtliche Regelungen:</p>
                  <ul className="legal-page__list">
                    <li>Berufsordnung der jeweiligen Ärztekammer</li>
                    <li>Heilberufsgesetze der Länder Hamburg und Niedersachsen</li>
                    <li>Gebührenordnung für Ärzte (GOÄ)</li>
                  </ul>

                  <p>Die berufsrechtlichen Regelungen sind einsehbar unter:</p>
                  <ul className="legal-page__list legal-page__links">
                    {chamberLinks.map((link) => (
                      <li key={link.href}>
                        <a href={link.href} target="_blank" rel="noopener noreferrer">
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </section>

                <section className="legal-page__section">
                  <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                  <div className="legal-page__stack">
                    <p>Aleksandr Sumenko</p>
                    <p>Eppendorfer Weg 111</p>
                    <p>20259 Hamburg</p>
                  </div>
                </section>

                <section className="legal-page__section">
                  <h2>Online-Terminvereinbarung</h2>
                  <p>
                    Die Online-Terminvereinbarung erfolgt über den externen Dienstleister
                    Doctolib.
                  </p>
                  <p>
                    Bei Nutzung der Online-Terminbuchung gelten zusätzlich die
                    Datenschutzbestimmungen des jeweiligen Anbieters.
                  </p>
                  <p>
                    Weitere Informationen unter:{' '}
                    <a
                      href="https://www.doctolib.de/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.doctolib.de
                    </a>
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                  <p>
                    Die Privatpraxis HanseEuroDerm PartG ist weder bereit noch verpflichtet,
                    an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                    teilzunehmen.
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Haftung für Inhalte</h2>
                  <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf
                    diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
                    10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
                    oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
                    forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                  <p>
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
                    nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
                    Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
                    Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen
                    werden wir diese Inhalte umgehend entfernen.
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Haftung für Links</h2>
                  <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte
                    wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte keine
                    Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
                    jeweilige Anbieter oder Betreiber der jeweiligen Seiten verantwortlich.
                  </p>
                  <p>
                    Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
                    Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                    Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der
                    verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                    Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
                    werden derartige Links umgehend entfernt.
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Urheberrecht</h2>
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website
                    unterliegen dem deutschen Urheberrecht. Jede Verwertung außerhalb der Grenzen
                    des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung der
                    jeweiligen Urheber bzw. Ersteller.
                  </p>
                  <p>
                    Downloads und Kopien dieser Seite sind ausschließlich für den privaten, nicht
                    kommerziellen Gebrauch gestattet.
                  </p>
                  <p>
                    Soweit Inhalte auf dieser Website nicht durch die Betreiber erstellt wurden,
                    werden die Urheberrechte Dritter beachtet und entsprechende Inhalte als
                    solche gekennzeichnet. Sollten Sie dennoch auf eine
                    Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden
                    Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden entsprechende Inhalte
                    umgehend entfernt.
                  </p>
                </section>

                <section className="legal-page__section">
                  <h2>Bildrechte</h2>
                  <p>
                    Die auf dieser Website verwendeten Fotos, Grafiken und sonstigen Abbildungen
                    sind urheberrechtlich geschützt.
                  </p>
                  <p>
                    Die Nutzungsrechte liegen bei der Privatpraxis HanseEuroDerm PartG oder
                    wurden ordnungsgemäß lizenziert.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer/>
    </Fragment>
  );
};

export default Impressum;
